<template>
  <div class="choose-photo layers" :class="{ 'read-only': readOnly }">
    <div class="scroller" ref="scroller" v-show="mode === 'guide' || mode === 'adjust'">
      <div class="long-content" ref="content">

        <div class="top-padding"></div>

        <div class="center-row step-indicator">
          <img class="step-1-img" src="./img/step-1.svg" />
          <img class="step-1-1440px" src="./img/step1-1440px.svg" alt="">
        </div>

        <div class="center-row step-title">{{ T('/choose-photo@step-1') }}</div>
        <div class="guide" v-show="mode === 'guide'">

            <div class="center-row step-select-image">
              {{ T('/choose-photo@choose-image') }}
            </div>

            <div class="yellow-line step-1-line">
            </div>

          <div class="guide-box">

            <div class="center-row-v take-photo" @click="goTakePhoto">
              <div class="take-photo-content">
                <div class="center-row">
                  <img src="./img/cam.svg" />
                </div>
                <div class="take-photo-text">
                  {{ T('/choose-photo@take-photo') }}
                  <input ref="system-photo-taker" class="hidden" capture="image" type="file" @change="chosenFile" accept="image/*" />
                </div>
              </div>
            </div>

            <div class="yellow-line step-2-line">
            </div>

            <div class="center-row-v upload-photo" @click="goUploadPhoto">
              <img src="./img/upload.svg" />
              <div class="upload-photo-text">
                {{ T('/choose-photo@upload-photo') }}
                <input ref="image-uploader" class="hidden" d-capture="d-image" type="file" @change="chosenFile" accept="image/*" />
              </div>
            </div>

            <div class="yellow-line">
            </div>

            <div class="center-row-v default-photo" @click="goDefaultPhoto">
              <div class="default-photo-text">
                {{ T('/choose-photo@default-photo') }}
              </div>
            </div>

          </div>



        </div>
        <div class="adjust" v-if="mode === 'adjust'">
          <div class="adjust-row">
            <div class="adjust-desc" v-if="!readOnly">{{ T('/choose-photo@please-center-photo') }}{{ T('/choose-photo@get-the-best-effect') }}</div>
            <div class="adjust-desc" v-if="readOnly">{{ T('/choose-photo@default') }}</div>

            <Adjuster
              v-if="imageURL"
              class="adjuster"
              ref="adjuster"
              :image="imageURL"
              :readOnly="readOnly"
            />
            <div class="choose-another-photo" @click="chooseAnotherPhoto">
              {{ T('/choose-photo@choose-another-photo') }}
            </div>
            <!-- <div class="go-next" @click="goNext">
              <img class="go-next-frame" src="./img/next.svg" />
              <div class="go-next-text">{{ T('/choose-photo@next') }}</div>
            </div> -->
            <CTA :text="T('/choose-photo@next')" @action="goNext" />
          </div>

        </div>

        <div class="bottom-padding"></div>

        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>

    <div class="cam-page" v-show="mode === 'cam-page'">
      <div class="center-row-v full">

        <div class="filler">
          <video v-show="!takenPhoto && readyVideo" class="video-viewer" ref="video-viewer" muted autoplay playsinline />
          <canvas v-show="takenPhoto" class="photo-viewer" ref="photo-taker" />
          <div class="position-button" v-show="canShowCaptures" v-if="SC.U === ENG">

            <!-- <button v-show="takenPhoto" @click="takenPhoto = !takenPhoto">Retry</button> -->
            <!-- <button v-show="takenPhoto" @click="useThisPhoto">Use this</button> -->
            <!-- <button v-show="!takenPhoto" @click="takePhoto()">Take photo</button> -->

            <img src="./img/retry.svg" v-show="takenPhoto" @click="takenPhoto = !takenPhoto" />
            <img src="./img/use-this.svg" v-show="takenPhoto" @click="useThisPhoto" />
            <img src="./img/back.svg" v-show="!takenPhoto" @click="goBackToMenu()" />
            <img src="./img/take-photo.svg" v-show="!takenPhoto" @click="takePhoto()" />
          </div>
          <div class="position-button" v-show="canShowCaptures" v-if="SC.U === CHI">
            <img src="./img/chi/retry.svg" v-show="takenPhoto" @click="takenPhoto = !takenPhoto" />
            <img src="./img/chi/use-this.svg" v-show="takenPhoto" @click="useThisPhoto" />
            <img src="./img/chi/back.svg" v-show="!takenPhoto" @click="goBackToMenu()" />
            <img src="./img/chi/take-photo.svg" v-show="!takenPhoto" @click="takePhoto()" />
          </div>
        </div>

      </div>
    </div>

    <!-- <FloatMenu class="hide-mobile float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu class="hide-mobile full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" /> -->
  </div>
</template>

<script>
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'
import * as PhotoStore from '@/components/DOM/PhotoStore/PhotoStore.js'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'
import Adjuster from '@/components/Parts/Adjuster/Adjuster.vue'

import CTA from '@/components/DOM/CTA/CTA.vue'

// import Instruction from './Instruction.vue'

export default {
  components: {
    Adjuster,
    FloatMenu,
    FullMenu,
    CTA
    // Instruction
  },
  data () {
    return {
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      fsMenu: false,
      clean () {},
      closeCam () {},
      mode: 'guide', // guide, cam-page, adjust
      canShowCaptures: false,
      takenPhoto: false,
      imageURL: false,
      PhotoStore,
      readOnly: false,
      readyVideo: false
    }
  },
  mounted () {
    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })

    if (this.$route.path === '/choose-photo/adjust-photo') {
      this.mode = 'adjust'

      if (PhotoStore.state.useDefaultPhoto) {
        this.readOnly = true
      }

      this.imageURL = PhotoStore.state.originalImageURL
      if (!this.imageURL) {
        this.$router.push('/choose-photo')
        this.mode = 'guide'
      }
    }
  },
  methods: {
    goBackToMenu () {
      this.$router.push('/choose-photo')
      this.mode = 'guide'
      ScrollMonitor.state.play = true
    },
    goNext () {
      PhotoStore.state.imageURL = this.$refs['adjuster'].toDataURL()
      this.$router.push({
        path: '/define-radiance'
      })
    },
    chooseAnotherPhoto () {
      this.$router.push('/choose-photo')
      this.takenPhoto = false
      this.mode = 'guide'
    },
    chosenFile (evt) {
      var file = evt.target.files[0]
      if (file) {
        var reader = new FileReader()
        reader.onload = () => {
          this.imageURL = reader.result
          PhotoStore.state.originalImageURL = this.imageURL
          this.mode = 'adjust'
          this.readOnly = false
        }
        reader.readAsDataURL(file)
      }
    },
    takePhoto () {
      var canvas = this.$refs['photo-taker']
      var video = this.$refs['video-viewer']
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
      this.imageURL = canvas.toDataURL()
      PhotoStore.state.originalImageURL = this.imageURL
      console.log(this.imageURL)
      this.takenPhoto = true
      this.readOnly = false
    },
    setupCamera () {
      return new Promise((resolve, reject) => {
        var constraints = {
          audio: false,
          video: true
        }
        var self = this
        var handleSuccess = (stream) => {
          var video = this.$refs['video-viewer']
          var videoTracks = stream.getVideoTracks()
          this.canShowCaptures = true
          console.log('Got stream with constraints:', constraints)
          console.log('Using video device: ' + videoTracks[0].label)
          stream.oninactive = function () {
            console.log('Stream inactive')
            // window.location.reload()
          }
          video.onplay = () => {
            resolve()
          }
          video.srcObject = stream
          self.readyVideo = true
          this.closeCam = () => {
            videoTracks[0].stop()
          }
        }

        function errorMsg (msg) {
          console.error(msg)
        }

        function handleError (error) {
          if (error.name === 'ConstraintNotSatisfiedError') {
            errorMsg('The resolution ' + constraints.video.width.exact + 'x' +
                constraints.video.width.exact + ' px is not supported by your device.')
          } else if (error.name === 'PermissionDeniedError') {
            errorMsg('Permissions have not been granted to use your camera and ' +
              'microphone, you need to allow the page access to your devices in ' +
              'order for the demo to work.')
          }
          errorMsg('getUserMedia error: ' + error.name, error)
          reject(error)
        }
        if (window.navigator.mediaDevices) {
          navigator
            .mediaDevices
            .getUserMedia(constraints)
            .then(handleSuccess)
            .catch(handleError)
        }
      })
    },
    useThisPhoto () {
      ScrollMonitor.state.play = true
      this.mode = 'adjust'
      PhotoStore.state.useDefaultPhoto = false
    },
    checkHasCam () {
      return new Promise((resolve, reject) => {
        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
          navigator.mediaDevices.enumerateDevices()
            .then((devices) => {
              var hasCam = false
              devices.forEach((device) => {
                if (device.kind === 'videoinput') {
                  hasCam = true
                }
              })
              if (hasCam) {
                resolve()
              } else {
                reject(new Error('no cam'))
              }
            })
            .catch((e) => {
              reject(new Error(e))
            })
        } else {
          reject(new Error('no cam'))
        }
      })
    },
    // checkIOSVersion () {
    //   function iOSversion () {
    //     if (/iP(hone|od|ad)/.test(navigator.platform)) {
    //       // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    //       var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
    //       return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)]
    //     }
    //   }
    // },
    checkAndroid () {
      var ua = navigator.userAgent.toLowerCase()
      var isAndroid = ua.indexOf('android') > -1
      return isAndroid
    },
    goTakePhoto () {
      if (this.checkAndroid()) {
        this.goUseWebCam()
      } else if (window.STAR_SKY_HAS_TOUCH || window.STAR_SKY_USE_UPLOAD) {
        this.$refs['system-photo-taker'].click()
      } else {
        this.goUseWebCam()
      }
    },
    goUseWebCam () {
      this.checkHasCam()
        .then(() => {
          this.$router.push('/choose-photo/take-photo')
          this.mode = 'cam-page'
          return this.setupCamera()
            .then(() => {
              // ScrollMonitor.state.play = false
              // this.$router.push('/choose-photo/take-photo')
              // this.mode = 'cam-page'
            }, () => {
              window.STAR_SKY_USE_UPLOAD = true
            })
        }, () => {
          this.$refs['system-photo-taker'].click()
        })
    },
    goUploadPhoto () {
      this.$refs['image-uploader'].click()
      PhotoStore.state.useDefaultPhoto = false
    },
    goDefaultPhoto () {
      this.imageURL = require('./img/default-avatar.jpg')
      PhotoStore.state.originalImageURL = this.imageURL
      PhotoStore.state.useDefaultPhoto = true
      this.mode = 'adjust'
      this.readOnly = true
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop
        ScrollMonitor.state.percentage = 0.2 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    if (this.closeCam) {
      this.closeCam()
    }
  }
}
</script>

<style scoped>
.choose-photo{
  color: white;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.long-content{
  height: 100%;
}
.menu-padder{
  height: 90px;
}
.taller{
  height: 75vh;
}

.bottom-padding{
  height: 1px;
}

.top-padding{
  height: 20px;
}
.center-row{
  display: flex;
  justify-content: center;
  align-items: center;
}


.center-row-v{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.guide{
  height: calc(100% - 80px);
}

.step-indicator{
  height: 20px;
}

.step-title{
  margin-top: 0px;
  /* step 1: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 10px;
  color: white;
  letter-spacing: 1.24px;
  text-align: center;
  line-height: 20px;

  transform: translateX(-138px);

  text-transform: uppercase;
}

.step-select-image{
  margin-top: 5px;
  /* Select an image: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.8px;
  text-align: center;
  line-height: 20px;

  text-transform: uppercase;
}

.yellow-line{
  height: 1px;
  background-color: #CEBC9E;
}
.step-1-line{
  margin-top: 20px;
}

.take-photo{
  cursor: pointer;
  height: 140px;
}

.take-photo-content{
  /* margin-top: 30px;
  margin-bottom: 30px; */
}

.take-photo-text{
  margin-top: 20px;
  /* Take Photo: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 18px;
  color: #CEBC9E;
  letter-spacing: 2.05px;
  text-align: center;
  line-height: 20px;
  text-transform: uppercase;
}

.step-2-line{
}

.upload-photo{
  cursor: pointer;
  height: 140px;
}

.upload-photo-text{
  margin-top: 20px;
  /* Take Photo: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 18px;
  color: #CEBC9E;
  letter-spacing: 2.05px;
  text-align: center;
  line-height: 20px;
  text-transform: uppercase;
}

.hidden{
  display: none;
}

.default-photo{
  cursor: pointer;
  height: 60px;
}

.default-photo-text{
  /* Take Photo: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 18px;
  color: #CEBC9E;
  letter-spacing: 2.05px;
  text-align: center;
  line-height: 20px;
  text-transform: uppercase;
}

@media screen and (max-width: 321px) {
  .default-photo{
    height: 73px;
  }
}

@media screen and (min-width: 375px) {
  .upload-photo,
  .take-photo{
    height: 48%;
  }
}

@media screen and (min-width: 414px) {
  .upload-photo,
  .take-photo{
    height: 48%;
  }
}

@media screen and (min-width: 415px) {
  .upload-photo,
  .take-photo{
    height: 43%;
  }
  .default-photo {
    height: 10%;
  }
}

.step-1-1440px{
  display: none;
}
.guide-box{
  height: calc(100% - 80px);
}
.hide-mobile{
  display: none;
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .hide-break{
    display: block;
  }
  .hide-mobile{
    display: block;
  }
  .step-title{
    font-size: 11px;
    transform: translateX(-279px);
  }
  .step-1-img{
    display: none;
  }
  .step-1-1440px{
    display: block;
  }
  .upload-photo-text,
  .take-photo-text{
    font-size: 20px;
    margin-top: 25px;
  }
  .upload-photo,
  .take-photo{
    height: 38%;
  }
  .default-photo {
    height: calc(24%);
  }
  .step-select-image{
    font-size: 20px;
    line-height: 30px;
    margin-top: 40px;
  }
  .guide{
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 230px);
  }
  .guide-box{
    margin-top: 65px;
    width: 600px;
    height: calc(100% - 80px);
    border: #CEBC9E solid 1px;
  }
  .step-select-image{
    margin-top: 30px;
  }
  .step-1-line{
    display: none;
  }
  .top-padding{
    height: 30px;
  }
}
/* camera page */
.cam-page{
  position: relative;
  width: 100%;
  height: calc(100%);
}
.photo-camera{
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.video-viewer{
  height: 100%;
}


.full{
  width: 100%;
  height: 100%;
}
.filler{
  /* width: 100vmin; */
  /* height: 100vmin; */
  width: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* @media screen and (min-width: 500px){
  .filler{
    overflow: hidden;
    height: 400px;
    width: 400px;
  }
} */

.position-button{
  position: absolute;
  bottom: 10vmin;
  width: 200px;
  left: calc(50% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.photo-viewer{
  height: 100%;
}
/* adjust */

.adjust{
  display: flex;
  justify-content: center;
  align-items: center;
}
.adjust-row{
  /* margin-top: 10px; */

  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 414px;

  flex-direction: column;
}

.adjust-desc{
  white-space: pre-line;
  /* Please Center your f: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.8px;
  text-align: center;
  line-height: 20px;
  margin-top: 10px;
  text-transform: uppercase;
}

.adjust-drag{
  margin-top: 10px;
  /* Drag the photo to ad: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 13px;
  color: #CEBC9E;
  letter-spacing: 0.93px;
  text-align: center;
  line-height: 20px;
}

.adjust-desc-2{
  /* Drag the photo to ad: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 13px;
  color: #CEBC9E;
  letter-spacing: 0.93px;
  text-align: center;
  line-height: 20px;
}

.adjuster{
  margin-top: 20px;
}
.layers:not(.read-only) .adjuster.adjuster{
  margin-bottom: -15px;
  margin-top: 70px;
}

.choose-another-photo{
  cursor: pointer;
  margin-top: 55px;
  /* Choose another photo: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #CEBC9E;
  letter-spacing: 1px;
  text-align: center;
  line-height: 20px;

  /* Line 3: */
  border-bottom: 1px solid #CEBC9E;
}

.go-next{
  cursor: pointer;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  width: 304px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.go-next-frame{
  transform: scale(0.9);
  position: absolute;
  top: -4px;
  left: -4px;
}

.go-next-text{
  text-transform: uppercase;
  /* next: */
  /* border: 0 solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}


@media screen and (min-width: 374px) {
  .go-next-frame {
    transform: scale(1.0);
  }
}

@media screen and (min-width: 413px) {
  .go-next-frame {
    transform: scale(1.1);
  }
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .adjust-drag {
    margin-top: 10px;
  }
  .adjust-desc{
    width: 500px;
    font-size: 20px;
    line-height: 30px;
    /* margin-top: 20px; */
    margin-top: 14px;
  }
  .adjuster{
    height: 400px;
    margin-top: 30px;
  }
  .input-row{
    margin-top: 43px;
  }
  .choose-another-photo{
    font-size: 14px;
    margin-top: 80px;
  }
  .go-next-frame{
    width:400px;
    margin-top: 20px;
    left: calc(50% - 400px / 2 + 4px)
  }
  .go-next-text{
    margin-top: 60px;
  }
  .cta-row{
    margin-top: 35px;
  }
}

/* @media screen and (width: 1024px) {
  .adjust{
    height: 80vmin;
  }
}
@media screen and (width: 768px) {
  .adjust{
    height: 80vmin;
  }
} */

</style>



// WEBPACK FOOTER //
// src/components/Pages/ChoosePhoto/ChoosePhoto.vue